import { connect } from 'react-redux'
import DonationSettingsCard from '../components/DonationSettingsCard'
import * as api from '../../../actions/api'

const mapStateToProps = (state, ownProps) => {
  const { width } = state.window
  const { settings } = state.settings
  return ({
    width,
    settings,
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
    handleClickSwitch: (data) => {
      dispatch(api.user.update(data))
    },
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DonationSettingsCard)


// WEBPACK FOOTER //
// ./src/Pages/Settings/containers/DonationSettingsCard.js